<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card class="full-width">
          <b-card-title>
            جزئیات دوره ورزشی
            <b-button
              v-if="showSaveButton"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1 position-fixed d-block"
              @click="save"
            >
              ذخیره
            </b-button>
          </b-card-title>
          <b-form
            ref="activitypackageform"
            @submit.prevent
          >
            <b-row align-h="center">
              <b-col
                class="mt-2"
                md="10"
              >
                <b-tabs>
                  <b-tab
                    active
                    @click="showSaveButton = false"
                  >
                    <template
                      #title
                      class="position-fixed"
                    >
                      <span class="d-none d-sm-inline">اطلاعات کلی</span>
                    </template>

                    <b-row class="mt-3">
                      <b-col md="3">
                        <b-form-group
                          label="عنوان"
                          label-for="Title"
                        >
                          <b-form-input
                            v-model="Form.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="برنامه ورزشی"
                          label-for="ActivityPackageId"
                        >
                          <z-activity-package
                            v-model="Form.ActivityPackageId"
                            :multiple="false"
                            :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                            label="سطح"
                            label-for="Level"
                        >
                          <v-select
                              v-model="Form.Level"
                              :options="enums('Level')"
                              dir="rtl"
                              label="text"
                              :reduce="x => x.value"
                              :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                            label="شناسه"
                            label-for="IdInStore"
                        >
                          <b-form-input
                              v-model="Form.IdInStore"
                              name="IdInStore"
                              autocomplete="off"
                              type="number"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                            label="ضریب سوخت و ساز"
                            label-for="MetCoefficient"
                        >
                          <b-form-input
                              v-model="Form.MetCoefficient"
                              name="IdInStore"
                              autocomplete="off"
                              type="number"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="قیمت"
                          label-for="Price"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              تومان
                            </b-input-group-prepend>
                            <cleave
                              id="Price"
                              v-model="Form.Price"
                              class="form-control"
                              :raw="false"
                              :options="options"
                              autocomplete="off"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="تخفیف"
                          label-for="Discount"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              تومان
                            </b-input-group-prepend>
                            <cleave
                              id="Discount"
                              v-model="Form.Discount"
                              class="form-control"
                              :raw="false"
                              :options="options"
                              autocomplete="off"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="وضعیت"
                          label-for="ActivationType"
                        >
                          <v-select
                            v-model="Form.ActivationType"
                            dir="rtl"
                            :reduce="x => x.value"
                            label="text"
                            :clearable="false"
                            :options="enums('ActivationType')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group class="mt-1 mb-2">
                          <b-form-checkbox
                            v-model="Form.IsIndividual"
                            value="true"
                            class="custom-control-primary"
                          >
                            ورزش انفردای می باشد.
                          </b-form-checkbox>

                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-row
                          v-for="(item, index) in Form.ActivityPackageCourseLanguage"
                          :key="index"
                        >
                          <b-col cols="12">
                            <hr>
                          </b-col>

                          <b-col md="5">
                            <b-form-group
                              label="زبان"
                            >
                              <z-language
                                v-model="item.Language"
                                :unselectable="Form.ActivityPackageCourseLanguage.map(x => x.Language)"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="5">
                            <b-form-group
                              label="عنوان"
                            >
                              <b-form-input
                                v-model="item.Title"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col
                            md="2"
                            class="mb-1"
                            style="display: flex; align-items: flex-end;"
                          >
                            <template v-if="ActivityPackageCourseLanguageRemoveId !== index">
                              <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle flat-left"
                                @click="removeActivityPackageCourseLanguage(index)"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                />
                              </b-button>
                            </template>
                            <template v-else>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle"
                                variant="outline-primary"
                                @click="cancelActivityPackageCourseLanguage"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle ml-1"
                                variant="outline-primary"
                                @click="confirmActivityPackageCourseLanguage"
                              >
                                <feather-icon icon="CheckIcon" />
                              </b-button>
                            </template>
                          </b-col>

                          <b-col cols="12">
                            <b-form-group
                              label="توضیحات"
                            >
                              <b-form-textarea
                                id="Description"
                                v-model="item.Description"
                                name="Description"
                                autocomplete="off"
                                rows="4"
                                no-resize
                              />
                            </b-form-group>
                          </b-col>

                        </b-row>
                      </b-col>

                      <b-col>
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          @click="addActivityPackageCourseLanguage"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                          />
                          <span>افزودن</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab @click="showSaveButton = true">
                    <template
                      #title
                      class="position-fixed"
                    >
                      <span class="d-none d-sm-inline">حرکات</span>
                    </template>
                    <b-row class="mt-3">
                      <b-col
                        v-for="(item, index) in Form.ActivityPackageCourseExercise"
                        md="12"
                      >
                        <b-card border-variant="secondary">
                          <b-row>
                            <template v-for="(exercise, indexexercise) in item.ActivityPackageCourseExerciseDetails">
                              <b-col lg="3">
                                <b-row no-gutters>
                                  <b-col md="10">
                                    <b-form-group
                                      label="حرکت"
                                    >
                                      <z-activity
                                        v-model="exercise.ActivityId"
                                        :multiple="false"
                                        :clearable="false"
                                      />
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    align-self="end"
                                    class="mb-1"
                                    style="margin-right:5px"
                                  >
                                    <b-button
                                      md="2"
                                      variant="outline-secondary"
                                      class="btn-icon"
                                      @click="onselect(exercise)"
                                    >
                                      <feather-icon icon="CameraIcon" />
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col lg="2">
                                <b-form-group
                                  label="پهلو"
                                >
                                  <v-select
                                    v-model="exercise.Side"
                                    dir="rtl"
                                    :reduce="x => x.value"
                                    label="text"
                                    :options="enums('ActivitySide')"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col lg="1">
                                <b-form-group
                                  label="ترتیب"
                                >
                                  <b-form-input
                                    v-model="exercise.Sort"
                                    autocomplete="off"
                                    type="number"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col lg="1">
                                <b-form-group
                                  label="نوع"
                                >
                                  <v-select
                                    v-model="exercise.Type"
                                    dir="rtl"
                                    :reduce="x => x.value"
                                    label="text"
                                    :clearable="false"
                                    :options="enums('ActivityAmountType')"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col lg="1">
                                <b-form-group :label="exercise.Type === 0 ? ' ثانِیه' : 'تعداد ' ">
                                  <b-form-input
                                    v-model="exercise.Amount"
                                    autocomplete="off"
                                    type="number"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col lg="2"
                                align-self="end"
                              >
                                <b-form-group>
                                  <b-form-checkbox
                                    v-if="exercise.Type === 0"
                                    v-model="exercise.PauseInMiddle"
                                    value="true"
                                    class="custom-control-primary"
                                  >
                                    توقف در ویدیو
                                  </b-form-checkbox>
                                </b-form-group>
                              </b-col>
                              <b-col lg="2"
                                align-self="end"
                                class="mb-1"
                              >
                                <template v-if="ActivityPackageExerciseDetailsRemoveId !== indexexercise">
                                  <b-button
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="btn-icon rounded-circle"
                                    @click="removeActivityPackageExerciseDetails(indexexercise)"
                                  >
                                    <feather-icon
                                      icon="TrashIcon"
                                    />
                                  </b-button>
                                </template>
                                <template v-else>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    class="btn-icon rounded-circle"
                                    variant="outline-primary"
                                    @click="cancelActivityPackageExerciseRemove"
                                  >
                                    <feather-icon icon="XIcon" />
                                  </b-button>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    class="btn-icon rounded-circle ml-1"
                                    variant="outline-primary"
                                    @click="confirmActivityPackageExerciseRemove(index)"
                                  >
                                    <feather-icon icon="CheckIcon" />
                                  </b-button>
                                </template>
                              </b-col>
                              <b-col lg="12"
                                v-if="exercise.showAssets"
                                class="mb-1"
                              >
                                <b-row align-h="start">
                                  <b-col md="auto">
                                    <b-overlay :show="exercise.loading">
                                      <uploadFile
                                        :value="exercise.Image"
                                        label="تصویر"
                                        :readonly="true"
                                      />
                                    </b-overlay>
                                  </b-col>
                                  <template v-if="exercise.Video.length>0">
                                    <template v-for="(video) in exercise.Video">
                                      <b-col md="auto">
                                        <b-overlay :show="exercise.loading">
                                          <uploadFile
                                            :value="video"
                                            label="ویدیو"
                                            :is-video="true"
                                            :readonly="true"
                                          />
                                        </b-overlay>
                                      </b-col>
                                    </template>
                                  </template>
                                </b-row>
                              </b-col>
                            </template>

                            <!--                          <b-col-->
                            <!--                            v-if="item.Type===1"-->
                            <!--                            md="3"-->
                            <!--                          >-->
                            <!--                            <b-form-group-->
                            <!--                              label="زمان انجام حرکت"-->
                            <!--                            >-->
                            <!--                              <b-input-group>-->
                            <!--                                <b-input-group-prepend is-text>-->
                            <!--                                  ثانیه-->
                            <!--                                </b-input-group-prepend>-->
                            <!--                                <cleave-->
                            <!--                                  v-model="item.TotalTime"-->
                            <!--                                  class="form-control"-->
                            <!--                                  :raw="false"-->
                            <!--                                  :options="options"-->
                            <!--                                  autocomplete="off"-->
                            <!--                                />-->
                            <!--                              </b-input-group>-->
                            <!--                            </b-form-group>-->
                            <!--                          </b-col>-->
                            <b-col
                              md="12"
                              class="mb-1"
                            >
                              <feather-icon
                                class="btn-icon btn-outline-info cursor-pointer"
                                icon="PlusIcon"
                                size="24"
                                @click="addActivity(item)"
                              />
                            </b-col>
                          </b-row>
                          <b-col cols="12">
                            <hr>
                          </b-col>
                          <b-row>
                            <b-col md="3">
                              <b-form-group
                                label="تعداد ست"
                              >
                                <b-form-input
                                  v-model="item.SetCount"
                                  autocomplete="off"
                                  type="number"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="3">
                              <b-form-group
                                label="زمان استراحت بعد از هر ست"
                              >
                                <b-input-group>
                                  <b-input-group-prepend is-text>
                                    ثانیه
                                  </b-input-group-prepend>
                                  <cleave
                                    v-model="item.SetRestTime"
                                    class="form-control"
                                    :raw="false"
                                    :options="options"
                                    autocomplete="off"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                            <b-col md="3">
                              <b-form-group
                                label="زمان استراحت بعد از اتمام"
                              >
                                <b-input-group>
                                  <b-input-group-prepend is-text>
                                    ثانیه
                                  </b-input-group-prepend>
                                  <b-form-input
                                    v-model="item.RestTime"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                            <b-col md="1">
                              <b-form-group
                                label="ترتیب"
                              >
                                <b-form-input
                                  v-model="item.Sort"
                                  autocomplete="off"
                                  type="number"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              class="mb-1 ml-auto text-right"
                              align-self="end"
                            >
                              <template v-if="ActivityPackageCourseDetailsRemoveId !== index">
                                <b-button
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="btn-icon rounded-circle"
                                  @click="removeActivityPackageCourseDetails(index)"
                                >
                                  <feather-icon
                                    icon="TrashIcon"
                                  />
                                </b-button>
                              </template>
                              <template v-else>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle"
                                  variant="outline-primary"
                                  @click="cancelActivityPackageCourseDetails"
                                >
                                  <feather-icon icon="XIcon" />
                                </b-button>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle ml-1"
                                  variant="outline-primary"
                                  @click="confirmActivityPackageCourseDetails"
                                >
                                  <feather-icon icon="CheckIcon" />
                                </b-button>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>

                      </b-col>
                      <b-col>
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          @click="addActivityPackageCourseDetails"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                          />
                          <span>افزودن</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
                <b-row>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZActivity from '@/tools/activity.vue'
import ZActivityPackage from '@/tools/activitypackage.vue'
import uploadFile from '@/tools/uploadFile.vue'

export default {
  name: 'ActivityPackageCourseDetails',
  components: {
    ZActivity,
    ZActivityPackage,
    uploadFile,
  },
  data() {
    return {
      showSaveButton: false,
      Form: {
        Id: null,
        IdInStore: null,
        Title: null,
        Price: 0,
        Discount: 0,
        Level: 0,
        ActivityPackageId: null,
        IsIndividual: true,
        ActivationType: 1,
        ActivityPackageCourseLanguage: [],
        ActivityPackageCourseExercise: [],
        MetCoefficient: null,
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 0,
      },
      ActivityPackageCourseLanguageRemoveId: null,
      ActivityPackageExerciseDetailsRemoveId: null,
      ActivityPackageCourseDetailsRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addActivityPackageCourseLanguage()
      this.addActivityPackageCourseDetails()
    }
  },
  methods: {
    onselect(item) {
      if (item.showAssets) {
        item.showAssets = false
        return false
      }
      item.showAssets = true
      item.loading = true
      this.$http.post(this.$api.activity.get, {
        Id: item.ActivityId,
      }).then(response => {
        item
          .Image = response.data.Image
        if (response.data.Video.length === 0) {
          item
            .Video = []
        } else {
          item
            .Video = response.data.Video.map(video => video.Video)
        }
      }).finally(() => { item.loading = false })
    },
    save() {
      let url = this.$api.activitypackagecourse.add
      if (this.$route.params.id) {
        url = this.$api.activitypackagecourse.update
      }

      const form = JSON.parse(JSON.stringify(this.Form))

      form.Price = form.Price.replaceAll(',', '')
      form.Discount = form.Discount.replaceAll(',', '')

      // form.append('ActivationType', this.Form.ActivationType)

      this.loading = true
      this.$http.post(
        url, form,
      ).then(()=>{
        if(url.includes('/add')) this.back()
      }).finally(() => {
        this.loading = false
      })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.activitypackagecourse.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Form.ActivityPackageCourseExercise = this.Form.ActivityPackageCourseExercise.map(item => {
            item.ActivityPackageCourseExerciseDetails = item.ActivityPackageCourseExerciseDetails.map(exercise => {
              this.$set(exercise, 'loading', false)
              this.$set(exercise, 'Image', false)
              this.$set(exercise, 'Video', [])
              this.$set(exercise, 'showAssets', false)
              return exercise
            })
            return item
          })
        })
    },
    addActivityPackageCourseLanguage() {
      this.Form
        .ActivityPackageCourseLanguage
        .push({
          Title: null, Language: null, Description: '',
        })
    },
    removeActivityPackageCourseLanguage(index) {
      this.ActivityPackageCourseLanguageRemoveId = index
    },
    confirmActivityPackageCourseLanguage() {
      this.Form.ActivityPackageCourseLanguage.splice(this.ActivityPackageCourseLanguageRemoveId, 1)
      this.ActivityPackageCourseLanguageRemoveId = null
    },
    cancelActivityPackageCourseLanguage() {
      this.ActivityPackageCourseLanguageRemoveId = null
    },
    addActivityPackageCourseDetails() {
      this.Form.ActivityPackageCourseExercise.push({
        RestTime: 0,
        SetCount: 0,
        SetRestTime: 0,
        Sort: 0,
        Side: null,
        ActivityPackageCourseExerciseDetails: [{
          ActivityId: null,
          Type: 0,
          Amount: 0,
          Sort: 0,
          Side: null,
          loading: false,
          Image: null,
          Video: [],
          showAssets: false,
        }],
      })
    },
    removeActivityPackageCourseDetails(index) {
      this.ActivityPackageCourseDetailsRemoveId = index
    },
    removeActivityPackageExerciseDetails(index) {
      this.ActivityPackageExerciseDetailsRemoveId = index
    },
    confirmActivityPackageCourseDetails() {
      this.Form.ActivityPackageCourseExercise.splice(this.ActivityPackageCourseDetailsRemoveId, 1)
      this.ActivityPackageCourseDetailsRemoveId = null
    },
    confirmActivityPackageExerciseRemove(index) {
      this.Form.ActivityPackageCourseExercise[index].ActivityPackageCourseExerciseDetails.splice(this.ActivityPackageExerciseDetailsRemoveId, 1)
      this.ActivityPackageExerciseDetailsRemoveId = null
    },

    cancelActivityPackageCourseDetails() {
      this.ActivityPackageCourseDetailsRemoveId = null
    },
    cancelActivityPackageExerciseRemove() {
      this.ActivityPackageExerciseDetailsRemoveId = null
    },

    addActivity(item) {
      item.ActivityPackageCourseExerciseDetails.push({
        ActivityId: null,
        Type: 0,
        Amount: 0,
        Sort: 0,
        Side: null,
        loading: false,
        Image: null,
        Video: [],
        showAssets: false,
      })
    },
  },
}
</script>

<style scoped>
</style>
